import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/approval-sales-profiles/save`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetCompanyById: `${endpointBackend}gci/companies/getById`,
        endpointGetAllCoreProfiles: `${endpointBackend}core/applicationsprofiles/getall`,
        endpointGetById: `${endpointBackend}gci/approval-sales-profiles/getById`,
        endpointGetAllApprovalSalesProfiles: `${endpointBackend}gci/approval-sales-profiles/getall`,
        urlGoBack: `/gci/approval-sales-profiles/list`,
        pathView: `/gci/approval-sales-profiles/view`
    }

    const labels = {
        labelTitleAdd: "Novo Perfil de Aprovação de Venda",
        labelTitleEdit: "Editar Perfil de Aprovação de Venda",
        labelTitleView: 'Visualizar Perfil de Aprovação de Venda'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true,
                        hasProfile: true
                    },
                    readOnly: !!id,
                    handleChange: async (element, field, values) => {
                        const company = await Fetch.post(paths.endpointGetCompanyById, { id: element.target.value });

                        values.profiles = [];

                        values.core_application_instance_id = company.core_application_instance_id

                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'profiles',
                    type: 'multiinput',
                    label: 'Perfis',
                    sortBy: 'index',
                    showDeleteButton: true,
                    form: [
                        {
                            name: 'core_application_profile_id',
                            type: 'select',
                            label: 'Perfil',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllCoreProfiles,
                                label: 'profile_name',
                                value: 'id',
                                params: {
                                    filter: {
                                        core_application_instance_id: values.core_application_instance_id ?? null,
                                        profileNotId: config.default_foreign_key.profiles.admin_gci
                                    }
                                }
                            },
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            customValidators: {
                hasProfile: async (values) => {
                    const profiles = await Fetch.post(paths.endpointGetAllApprovalSalesProfiles, {
                        filter: {
                            gci_company_id: values.gci_company_id
                        }
                    });

                    if (profiles.length > 0 && !id) {
                        return '^Já existe um perfil de aprovação de venda cadastrado para esta empresa.';
                    }

                    return '';
                }
            },
            ...paths,
            ...labels,
        }

        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (profileFilter.gci_company_id) {
                const company = await Fetch.post(paths.endpointGetCompanyById, { id: profileFilter.gci_company_id });
                values.core_application_instance_id = company.core_application_instance_id;
            }

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}

export default Form;
